<style type="text/css" lang="scss">
	@import '../../../../static/css/reset.scss';
</style>
<template>
	<div class="search-list">
		<div class="search-header">
			<div class="header-content">
				<div class="logo" @click="toIndex"></div>
				<div class="search-box">
					<input v-model="keyword" placeholder="请输入关键词" class="search-inp">
					<span @click="query" class="search-btn">搜索</span>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="content-left">
				<div class="article-list loading" v-if="showLoading">
				    <loading :width="loadingWidth"></loading>
				</div>
				<div class="article-list" v-if="articles.length > 0 && !showLoading">
				    <div class="article-item" v-for="(item, index) in articles" :key="index">
				    	<div class="item-content">
				    		<div class="item-img" v-on:click="jumpToDetail(item.url)" v-if="item.attachment">
				    			<img :src="item.attachment" />
				    		</div>
				    		<div :class="item.attachment ? 'item-desc' : 'item-desc-noImg'">
				    			<div class="desc-title" v-on:click="jumpToDetail(item.url)">{{item.title}}</div>
				    			<div class="desc-content">{{item.content}}</div>
				    			<div class="desc-skip">
				    				<span v-on:click="jumpToDetail(item.url)" class="skip-address">{{item.url}}</span>
				    				<span class="skip-date">{{item.publishTime}}</span>
				    			</div>
				    		</div>
				    	</div>
				    </div>
				</div>
				<div class="article-list no-data" v-if="articles.length === 0 && !showLoading">
				    <no-data :title="noDataTitle" :img-style="noDataStyle"></no-data>
				</div>
				<div class="select-page" v-if="pageTotal > 0">
				    <pagination :pageIndex="pageNum" :totalNum="pageTotal"  v-on:changeItem="changePage"></pagination>
				</div>
			</div>
			<div class="content-right">
				<div v-for="(item, index) in rightAds" :key="index" class="ad-right-item" v-if="rightAds.length > 0">
				    <advertisement :img-url="item.thumb" :ad-url="item.adsUrl"></advertisement>
				</div>
				<div class="currency-list" :class="rightAds.length > 0 ? 'm-top': ''">
				    <quotation :more-url="moreCurrencyUrl"></quotation>
				</div>
			</div>
			
		</div>
		<!-- footer -->
		<ui-footer></ui-footer>
	</div>
</template>
<script>
	import API from 'newsApi'
	import UiFooter from 'uiFooter'
	import Loading from 'loading'
	import Quotation from 'quotation'
	import Pagination from 'commonPagination'
	import NoData from 'noData'
	import Advertisement from 'advertisement'
	export default {
		components: {
			UiFooter,
			Loading,
			Quotation,
			Pagination,
			NoData,
			Advertisement
		},
		data: function() {
			return {
				keyword: '',
				prevKeyword: '',
				rightAds: [],
				moreCurrencyUrl: window.PAGE_DATA.commonData.ucenterPath || '',
				homeUrl: window.PAGE_DATA.commonData.homeUrl || '',
				pageTotal: 0,
				pageNum: 1,
				articles: [],
				noDataTitle: '暂无数据',
				noDataStyle: {
				    'padding-top': '5px',
				    'width': '600px',
				    'height': '360px'
				},
				showLoading: false,
				loadingWidth: '100px',
			}
		},
		created: function() {
			this.initAds();	
			let str = window.location.search;
			if(!str) {
				return;				
			}		
			this.keyword = this.getParams(str, 'keyword');	
			if(!this.keyword) {
				return;
			}
			this.prevKeyword = this.keyword;
			let params = {
				keyword: this.keyword,
				page: this.pageNum
			};
			this.initArticleList(params);
					
		},
		methods: {			
			query: function(){
				if(this.prevKeyword === this.keyword) {
					return;
				}
				this.pageNum = 1;
				let params = {
				    page: this.pageNum,
				    keyword: this.keyword
				};
				this.prevKeyword = this.keyword;
				this.pageTotal = 0;
				this.initArticleList(params);
			},
			toIndex:function(){
			    window.location.href = this.homeUrl;
			},
			jumpToDetail:function(articleUrl){
				window.open(articleUrl);
			},
			changePage: function(index) {
			    this.pageNum = index;
			    let params = {
			        page: this.pageNum,
			        keyword: this.keyword
			    };
			    this.initArticleList(params);
			    $("html,body").animate({"scrollTop":0},1000);
			},
			initArticleList: function(params) {
				this.showLoading = true;
				this.articles = [];

				let self = this;
				API.getWholeArticleList(params).then((data)=>{
					
				    let res = data.data;
				    if (res.header.code == 1){
				        let list = res.body.list;
				        list.forEach((item)=>{
				            self.articles.push(item);
				        })			
				        self.showLoading = false;	        
				        if (list.length > 0){
				            self.pageTotal = res.body.pagePages;
				        }else{
				        	self.pageTotal = 0;
				        }
				    }else {
				    	self.showLoading = false;
				    	self.pageTotal = 0;
				    }

				}).catch((err)=>{

				})
			},
			initAds: function(){
				let self = this;
				API.getSearchAds().then((data)=>{
				    let res = data.data;
				    if (res.header.code == 1){
				        self.rightAds = res.body;			        
				        	
				    }

				}).catch((err)=>{

				})
			},
			getParams: function(str, name){
				let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
				let val = str.substr(1).match(reg);
				if(val != null) {
					return decodeURI(val[2]);
				}
				return null;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.search-list {
		width: 100%;
		height: 100%;

		.search-header {
			width: 100%;
			height: 70px;
			background-color: #364983;

			.header-content {
				width: 1120px;
				height: 100%;
				margin: 0 auto;

				.logo {
					float: left;
					width:297px;
                    height:34px;
                    margin-top:18px;
                    background-image: url('./images/logo.png');
                    background-size: cover;
                    cursor:pointer;
				}
				.search-box {
					float: right;
				    width: 360px;
				    height: 32px;
				    margin-top: 19px;
				    border-bottom: 1px solid rgba(255,255,255,0.16);
				    padding: 6px 0px;
				    
				    .search-inp {
				        float: left;
				        width: 300px;
				        height: 100%;
				        padding-left: 10px;
				        border-right: 1px solid rgba(255,255,255,0.16);
				        font-size: 14px;	
				        color: rgba(255,255,255,0.6);			        
				    }
				    .search-btn {
				        float: left;
				        width: 60px;
				        height: 100%;
				        padding-left: 26px;
				        font-size: 14px;
				        cursor: pointer;
				        color: rgba(255,255,255,0.6);
				        background: url("./images/search.png") no-repeat 6px center;
				        background-size: 14px 14px;
				    }
				    .search-inp::-webkit-input-placeholder {
				    	color: rgba(255,255,255,0.6)
				    }
				    .search-inp::-moz-placeholder {
				    	color: rgba(255,255,255,0.6)
				    }
				    .search-inp:-moz-placeholder {
				    	color: rgba(255,255,255,0.6)
				    }
				    .search-inp:-ms-placeholder {
				    	color: rgba(255,255,255,0.6)
				    }
				}
			}
		}
		.content {
			width: 1120px;
			margin: 20px auto;
			.content-left {
				float: left;
				width: 740px;
				
				.article-item {
					padding: 30px 0px;
					border-bottom: 1px solid rgba(0,0,0,0.12);
					&:last-child {
						border-bottom: none;
					}
					.item-content {
						width: 100%;
						height: 88px;
					}
					.item-img {
						float: left;
						width: 142px;
						height: 88px;
						margin-right: 20px;
						cursor: pointer;
					}
					.item-desc {
						float: left;
						width: 518px;						
						font-size: 12px;
						color: #9B9B9B;						
					}
					.item-desc-noImg {
						width: 100%;						
						font-size: 12px;
						color: #9B9B9B;	
					}
					.desc-title {
						font-size: 18px;
						line-hight: 25px;
						color: #333;
						cursor: pointer;
					}
					.desc-content {
						line-height: 17px;
						padding: 6px 0px 8px;
					}
					.desc-skip {
						height: 18px;
						.skip-address {
							float: left;
							cursor: pointer;
						}
						.skip-date {
							float: right;
						}
					}
				}
				.article-list {
					padding: 20px 30px;
					background: #fff;
					&.loading{
					    padding-top: 150px;
					    height: 484px;
					}
					&.no-data{
					    height: 484px;
					}
				}
			}
			.content-right {
				float: right;
				width: 360px;
				.ad-right-item{
				    margin-top: 18px;
				    height: 88px;
				    &:first-child{
				        margin-top: 0px;
				    }
				}
				.currency-list {
				    &.m-top {
				        margin-top: 20px;
				    }
				}
			}
			.select-page {
			    margin: 40px 0px;
			    text-align: center;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/information/view/searchList/SearchList.vue